import { lazyLoad } from 'utils/loadable';

export const OperatorInfoPage = lazyLoad(
  () => import('./index'),
  module => module.OperatorInfoPage,
);
